import { Pipe, PipeTransform } from '@angular/core';
import { Option } from '@dch/products-business-logic';

@Pipe({
  name: 'excludeFlexEmergency',
})
export class ExcludeFlexEmergencyPipe implements PipeTransform {
  transform(values: Array<Option>): any {
    return (values || []).filter((v) => v.optionCodeForDescription !== 'MEGMK');
  }
}
